module.exports = __webpack_public_path__ + "static/media/59.b14d00d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/59.svg
// module id = 163
// module chunks = 0